module.exports = __webpack_public_path__ + "static/media/sensitive-male.974031dd.png";